// extracted by mini-css-extract-plugin
export default {"container":"serviceCard_container__1GXv3","contractingBorder":"serviceCard_contractingBorder__UETCJ","quoteCheck":"serviceCard_quoteCheck__tHyt0"};